module.exports = __webpack_public_path__ + "img/dl006x2.prt.31709bd3.jpg";